import { useCoachPortfolioRuntime } from "@/hooks/useCoachPortfolioRuntime";
import type { CoachRuntimeContextType } from "@/lib/behavior/behaviorContracts";

export function useCoachSurfaceRuntime(params: {
  coachId?: string;
  contextType: CoachRuntimeContextType;
  enabled?: boolean;
}) {
  const { coachId, contextType, enabled = true } = params;

  return useCoachPortfolioRuntime({
    coachId,
    contextType,
    enabled,
  });
}
